import { atom } from 'jotai'
import type {
    FGSettings,
    FGFlavor,
    FGProducts,
    FGProductV2,
    FGPurchaseOption,
    FGSubscribeConfig,
    FGDefaultValues,
    FGTermAndConditions,
    FGBuyNowButton,
    FGSettingsFormInput
} from './feelgreat.types'

export const feelgreatSettingsAtom = atom<FGSettings | null>(null)
export const isFeelGreatLoadingAtom = atom<boolean>(false)

// Server-driven checkout form definitions (per country). Empty until settings load.
export const fgCreateAccountInputsAtom = atom<FGSettingsFormInput[]>(get => get(feelgreatSettingsAtom)?.createYourAccount?.inputs ?? [])
export const fgShippingAddressInputsAtom = atom<FGSettingsFormInput[]>(get => get(feelgreatSettingsAtom)?.shippingAddress?.inputs ?? [])

export const fgFlavorsAtom = atom<FGFlavor[]>(get => get(feelgreatSettingsAtom)?.flavors ?? [])

export const fgProductsAtom = atom<FGProducts>(get => get(feelgreatSettingsAtom)?.products ?? {})

export const fgPurchaseOptionsAtom = atom<FGPurchaseOption[]>(get => get(feelgreatSettingsAtom)?.purchaseOptions ?? [])

export const fgPurchaseOptionsV2Atom = atom<FGPurchaseOption[]>(get => get(feelgreatSettingsAtom)?.purchaseOptionsV2 ?? [])

export const fgSubscribeConfigAtom = atom<FGSubscribeConfig | null>(get => get(feelgreatSettingsAtom)?.subscribeConfig ?? null)

export const fgDefaultValuesAtom = atom<FGDefaultValues>(
    get =>
        get(feelgreatSettingsAtom)?.defaultValues ?? {
            flavor: 'flavor_0',
            purchaseOption: 'subscribe'
        }
)

export const fgSelectedItemVersionAtom = atom<string>(get => get(feelgreatSettingsAtom)?.selectedItemVersion ?? 'v1')

/** Which UI card style to use: 'v1' = simple, 'v2' = enhanced with headerBadge/benefits */
export const fgCardVersionAtom = atom<string>(get => get(fgSubscribeConfigAtom)?.subscriptionCardVersion ?? 'v1')

/** Effective purchase options to display (prefer V2 if available) */
export const fgActivePurchaseOptionsAtom = atom<FGPurchaseOption[]>(get => {
    const v2 = get(fgPurchaseOptionsV2Atom)
    const v1 = get(fgPurchaseOptionsAtom)
    return v2.length > 0 ? v2 : v1
})

export const fgProductsV2Atom = atom<FGProductV2[]>(get => (get(feelgreatSettingsAtom)?.productsV2 as FGProductV2[] | undefined) ?? [])

export const fgUseComplexPasswordAtom = atom<boolean>(get => get(feelgreatSettingsAtom)?.passwordSettings?.isUseComplexPassword ?? false)

export const fgTermAndConditionsAtom = atom<FGTermAndConditions | null>(get => get(feelgreatSettingsAtom)?.termAndConditions ?? null)

export const fgBuyNowButtonAtom = atom<FGBuyNowButton | null>(get => get(feelgreatSettingsAtom)?.buyNowButton ?? null)
